import React, { Suspense, lazy, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import weChatSDK from "./utils/wechat";

const Home = lazy(() => import("./pages/home"));

const AnalysisArticle = lazy(() => import("./pages/analysis-article/index"));
const PreviewWords = lazy(() => import("./pages/preview-words/index.jsx"));
const CreateBookName = lazy(() => import("./pages/create-book-name/index.jsx"));
const EditorBook = lazy(() => import("./pages/editor-book/index.jsx"));
const FileRecognition = lazy(() =>
  import("./pages/file-recognition/index.jsx")
);
const AddWords = lazy(() => import("./pages/add-words/index.jsx"));
/**
 React.lazy 目前只支持默认导出（default exports）。
 如果你想被引入的模块使用命名导出（named exports），
 你可以创建一个中间模块，来重新导出为默认模块。
 这能保证 tree shaking 不会出错，并且不必引入不需要的组件。
 */

const App = () => {
  useEffect(() => {
    // 初始化微信SDK
    weChatSDK.init();
  }, []);

  return (
    <Router>
      <Suspense
        fallback={
          <div
            style={{
              color: "#717171",
              height: "100vh",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Loading...
          </div>
        }
      >
        <Switch>
          <Route exact path="/" component={Home} />
          <Route
            exact
            path="/editor_book/:user_id/:book_id"
            component={EditorBook}
          />
          <Route
            exact
            path="/analysis_article/:user_id"
            component={AnalysisArticle}
          />
          <Route
            exact
            path="/preview_words/:user_id"
            component={PreviewWords}
          />
          <Route
            exact
            path="/create_book_name/:user_id"
            component={CreateBookName}
          />
          <Route
            exact
            path="/file_recognition/:user_id"
            component={FileRecognition}
          />
          <Route exact path="/add-words/:user_id" component={AddWords} />
        </Switch>
      </Suspense>
    </Router>
  );
};
export default App;
